const getHeaders = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json'
})

export default getHeaders